import { create } from "zustand";

interface IFeed {
  page?: number | null;
  pages?: number | null;
  total?: number | null;
  feedId?: string | null;
  ids: string[];
  boostedIds?: string[];
}

interface IFeedsState {
  feeds: {
    [key: string]: IFeed;
  };
  appendFeed: (key: string, props: IFeed) => void;
  updateFeed: (key: string, props: IFeed) => void;
  getFeed: (key: string) => IFeed | undefined;
}

const mergeFeed = (newFeed: IFeed, oldFeed?: IFeed) => {
  const previousIds = oldFeed ? oldFeed.ids : [];
  const previousBoostedIds = oldFeed && oldFeed.boostedIds ? oldFeed.boostedIds : [];
  const newBoostedIds = newFeed.boostedIds ?? [];

  return {
    ...newFeed,
    ids: [
      ...previousIds,
      ...newFeed.ids.filter(id => !previousIds.includes(id))
    ],
    boostedIds: [
      ...previousBoostedIds,
      ...newBoostedIds.filter(id => !previousBoostedIds.includes(id))
    ]
  };
};

export const useFeedsStore = create<IFeedsState>(
  (set, get) => ({
    feeds: {},
    appendFeed: (key: string, feed: IFeed) => {
      set(({ feeds }) => ({
        feeds: {
          ...feeds,
          [key]: mergeFeed(feed, feeds[key])
        }
      }));
    },
    updateFeed: (key: string, feed: IFeed) => {
      set(({ feeds }) => ({
        feeds: {
          ...feeds,
          [key]: { ...feeds[key], ...feed }
        }
      }));
    },
    getFeed: (key: string) => get().feeds[key],
  }),
);
